import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Modal,
  Menu,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Button,
  IconButton,
  TablePagination,
  CircularProgress,
  Backdrop,
  Chip,
} from "@mui/material";
import { MoreVert, Close, Check } from "@mui/icons-material";

import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
// import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { ArrowRightIcon } from "@mui/x-date-pickers";
import { add } from "date-fns";
const vendorsData = [
  { variant_id: "1", title: "Variant 1" },
  { variant_id: "2", title: "Variant 2" },
  { variant_id: "3", title: "Variant 3" },
];

const categoryOptions = ["Category 1", "Category 2"];
const subCategoryOptions = ["Sub-category 1", "Sub-category 2"];
const variantOptions = ["Variant A", "Variant B", "Variant C"];

export default function Adminvariantproperties() {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const [isLoadingProgress, setIsLoading] = useState(false);
  const loginToken = useSelector((state) => state.user.logintoken);

  const [vendors, setVendors] = useState();
  const [varaintsNames, setVariantsNames] = useState([]);
  const [options, setOptions] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [search, setSearch] = useState("");
  // const [variantNameError, setVariantNameError] = useState("");
  const [variantNameError, setVariantNameError] = useState(null);
  const [propertiesError, setPropertiesError] = useState("");

  const [showOptionInput, setShowOptionInput] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentVariant, setCurrentVariant] = useState({
    name: "",
    options: [],
    status: "Active",
  });
  const [variant, setVariant] = useState("");
  const [newOption, setNewOption] = useState("");

  const handleAddOptionClick = () => {
    setShowOptionInput(true);
  };

  const handleAddVariant = () => {
    if (
      newVendor.variant_id &&
      !newVendor.selectedVariants.includes(newVendor.variant_id)
    ) {
      setNewVendor((prevState) => ({
        ...prevState,
        selectedVariants: [...prevState.selectedVariants, newVendor.variant_id],
        variant_id: "", // Reset the dropdown after selection
      }));
    }
  };

  const handleRemoveVariant = (variantId) => {
    setNewVendor((prevState) => ({
      ...prevState,
      selectedVariants: prevState.selectedVariants.filter(
        (id) => id !== variantId,
      ),
    }));
  };
  const [newVendor, setNewVendor] = useState({
    sno: "",
    variantName: "",
    variant_id: 0,
    category: "",
    subCategory: "",
    properties: "",
    status: "",
    variant_id: "",
    selectedVariants: [],
  });

  const getInitialFormValues = () => ({
    category_id: selectedVendor ? selectedVendor.category_id : "",
    category_name: selectedVendor ? selectedVendor.category_name : "",
    subCategory_id: selectedVendor ? selectedVendor.sub_cat_id : "",
    subCategory_name: selectedVendor ? selectedVendor.sub_category_name : "",
    variant_id: selectedVendor ? selectedVendor.variant_id : "",
    variant_name: selectedVendor ? selectedVendor.title : "",
    options: selectedVendor ? selectedVendor.options : [],
    status: selectedVendor ? selectedVendor.status : "",
  });
  const [formValues, setFormValues] = useState(getInitialFormValues());

  const {
    data: variantPropData,
    isLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllVariantsProperties"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createCategoryData,
    isLoading: createCategoryLoading,
    error: createCategoryError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVariantsProperties"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updatedVariantPropData,
    isLoading: updatedVariantPropLoading,
    error: updatedVariantPropError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deletedVariantPropData,
    isLoading: deletedVariantPropLoading,
    error: deletedVariantPropError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (error) {
    } else if (variantPropData && variantPropData["status"] === true) {
      console.log("varianpro", variantPropData);
      setVendors(variantPropData["data"]);
      const result = variantPropData.data.map((item) => ({
        title: item.title,
        variant_id: item.variant_id,
      }));
      setVariantsNames(result);
    }
  }, [variantPropData, error]);

  useEffect(() => {
    if (updatedVariantPropError) {
    } else if (
      updatedVariantPropData &&
      updatedVariantPropData["status"] === true
    ) {
      console.log("updatedVariantPropData", updatedVariantPropData["data"]);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedVariantPropData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [updatedVariantPropData, updatedVariantPropError]);

  useEffect(() => {
    if (createCategoryError) {
    } else if (createCategoryData && createCategoryData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      setNewVendor({
        category: "",
        properties: "",
        selectedVariants: "",
        sno: "",
        status: "",
        subCategory: "",
        variant_id: "",
        variantName: "",
      });
      setVariantNameError("");
      setPropertiesError("");
      fetchData();
    }
  }, [createCategoryData, createCategoryError]);

  useEffect(() => {
    console.log("selectedVendoruseeffec", selectedVendor);
    if (selectedVendor?.options) {
      console.log("Options:", selectedVendor.options);
    }
  }, [selectedVendor]);

  useEffect(() => {
    if (deletedVariantPropError) {
    } else if (
      deletedVariantPropData &&
      deletedVariantPropData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedVariantPropData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      // setModalOpen(false);

      setIsLoading(false);
      handleMenuClose();
      fetchData();
    }
  }, [deletedVariantPropData, deletedVariantPropError]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  const handleMenuClick = (event, vendor) => {
    console.log("selectedVendro", vendor);
    setAnchorEl(event.currentTarget);
    setSelectedVendor(vendor);
    // setOptions(vendor["options"]);
    // const optionNames = vendor.options.map(option => option.option_name);
    setSelectedOptions(vendor["options"]);
    // setSelectedOptions(vendor["options"])

    setFormValues({
      category_id: vendor.category_id,
      category_name: vendor.category_name,
      subCategory_id: vendor.sub_cat_id,
      subCategory_name: vendor.sub_category_name,
      variant_id: vendor.variant_id,
      variant_name: vendor.title,
      status: vendor.status,
      options: vendor.options,
    });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedVendor(null);
  };

  // const handleEditVendor = () => {
  //   setModalOpen(true);
  //   setIsEditing(true);
  //   setNewVendor(selectedVendor);
  //   handleMenuClose();
  // };

  const handleEditVendor = () => {
    setModalOpen(true);
    setIsEditing(true);
    setNewVendor({
      sno: selectedVendor.sno,
      variantName: selectedVendor.title, // Use title as variant name
      variant_id: selectedVendor.variant_id,
      category: selectedVendor.category_name || "",
      subCategory: selectedVendor.sub_category_name || "",
      properties: selectedVendor.options
        ? selectedVendor.options.map((option) => option.option_name).join(", ")
        : "",
    });

    handleMenuClose();
  };

  // const handleDelete = () => {
  //   // setVendors(vendors.filter((v) => v.sno !== selectedVendor.sno));
  //   console.log("newVendroDel", selectedVendor);
  //   const deleteUrl = urls(
  //     "deleteVariantsProperties",
  //     selectedVendor["variant_id"]
  //   );
  //   fetchDeleteData(deleteUrl);
  // };

  // Resusable Loadin compoennt shoudl chagne to componenst folder
  const LoadingOverlay = ({ open }) => {
    return (
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={open}
      >
        <CircularProgress color="primary" />
        <Typography variant="h6">Deleting variant...</Typography>
      </Backdrop>
    );
  };

  //  const handleRemoveOption = async (optionToRemove,variantId=0) => {
  //     try {

  //         setIsLoading(true);

  //         const deleteUrl = urls("deleteVariantsProperties", variantId);

  //         const response = await fetchDeleteData(deleteUrl);

  //         if (response.success) {

  //             setSelectedOptions(prevOptions =>
  //                 prevOptions.filter(option => option.variant_id !== variantId)
  //             );
  //             setCurrentVariant(prev => ({
  //               ...prev,
  //               options: prev.options.filter(option => option !== optionToRemove)
  //           }));
  //             // setSelectedOptions(selectedOptions.filter(option => option.option_name !== optionToRemove));

  //             // toast.success("Variant deleted successfully");
  //         } else {

  //             throw new Error(response.message || "Failed to delete variant");
  //         }
  //     } catch (error) {

  //         console.error("Error deleting variant:", error);
  //         // toast.error("Failed to delete variant. Please try again.");
  //     } finally {

  //         // setIsLoading(false);
  //     }
  // };

  const handleRemoveOption = async (optionToRemove, variantId = 0) => {
    try {
      setIsLoading(true);

      if (isEditing) {
        const deleteUrl = urls("deleteVariantsProperties", variantId);
        const response = await fetchDeleteData(deleteUrl);

        if (response.success) {
          // Ensure we're working with arrays
          setSelectedOptions((prevOptions) =>
            prevOptions.filter(
              (option) => option.variant_option_id !== variantId,
            ),
          );

          setFormValues((prev) => ({
            ...prev,
            options: Array.isArray(prev.options)
              ? prev.options.filter((opt) =>
                  typeof opt === "object"
                    ? opt.variant_option_id !== variantId
                    : opt !== optionToRemove,
                )
              : [],
          }));

          setCurrentVariant((prev) => ({
            ...prev,
            options: Array.isArray(prev.options)
              ? prev.options.filter((option) => option !== optionToRemove)
              : [],
          }));
        } else {
          throw new Error(response.message || "Failed to delete variant");
        }
      } else {
        // Non-editing mode
        setSelectedOptions((prevOptions) =>
          Array.isArray(prevOptions)
            ? prevOptions.filter((option) => option !== optionToRemove)
            : [],
        );

        setFormValues((prev) => ({
          ...prev,
          options: Array.isArray(prev.options)
            ? prev.options.filter((opt) => opt !== optionToRemove)
            : [],
        }));

        setCurrentVariant((prev) => ({
          ...prev,
          options: Array.isArray(prev.options)
            ? prev.options.filter((option) => option !== optionToRemove)
            : [],
        }));
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddVendor = () => {
    console.log("variantupdate", formValues["status"]);

    console.log("variantupdate", options);
    if (isEditing) {
      const objects = formValues["options"]
        .filter((item) => typeof item === "object")
        .map((obj) => ({
          ...obj,
          status: Number(formValues["status"]),
        }));

      // const objects = formValues['options'].filter(item => typeof item === 'object');
      const strings = formValues["options"].filter(
        (item) => typeof item === "string",
      );
      console.log("strings", strings);

      const newColorObjects = strings.map((color) => ({
        variant_option_id: 0,
        variant_id: formValues["variant_id"],
        option_name: color.toLowerCase(),
        status: formValues["status"],
      }));
      const finalColorArray = [...objects, ...newColorObjects];

      const updateUrl = urls(
        "updateVariantsProperties",
        newVendor["variant_id"],
      );

      console.log("variantupdate optionsDta", finalColorArray);
      fetchUpdateData(updateUrl, { options: finalColorArray });
    } else {
      console.log("optionsDta", "add", newVendor, selectedOptions);
      if (!formValues.variant_id) {
        setVariantNameError("Variant name is required");
        return;
      }
      if (!selectedOptions > 0) {
        setPropertiesError("Options name is required");
        return;
      }

      fetchCreateData({
        variant_id: parseInt(formValues.variant_id),
        options: selectedOptions,
      });

      setNewVendor({
        sno: "",
        variantName: "",
        category: "",
        subCategory: "",
        properties: "",
      });
      setVariantNameError("");
      setPropertiesError("");
      setModalOpen(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  // const handleOptionSubmit = () => {
  //   console.log("newOption",newOption)
  //   if (newOption.trim()) {
  //     setSelectedOptions([...selectedOptions, newOption.trim()]);

  //     setNewOption("");
  //     setShowOptionInput(false);
  //   }
  // };

  const handleOptionSubmit = () => {
    console.log("newOption", newOption);
    if (newOption.trim()) {
      if (isEditing) {
        const newOptionObject = {
          variant_option_id: 0, // Set to 0 for new options
          variant_id: formValues.variant_id,
          option_name: newOption.trim(),
          status: formValues.status,
        };
        setSelectedOptions([...selectedOptions, newOptionObject]);

        setFormValues((prev) => ({
          ...prev,
          options: [...prev.options, newOptionObject],
        }));
      } else {
        setSelectedOptions([...selectedOptions, newOption.trim()]);
        setFormValues((prev) => ({
          ...prev,
          options: [...prev.options, newOption.trim()],
        }));
      }
      setNewOption("");
      setShowOptionInput(false);
    }
  };

  const handleModalClose = () => {
    // setFormValues({...formValues,variant_id:""})
    setModalOpen(false);
  };
  console.log("selectedOptis", selectedOptions);

  // const handleRemoveOption = (optionToRemove,variantId=0) => {
  //   console.log("optionRemove",optionToRemove,variantId);

  //   setSelectedOptions(selectedOptions.filter(option => option.option_name !== optionToRemove));
  // };
  console.log("optionRemove selectedOp", selectedOptions);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleOptionSubmit();
    }
  };

  const resetData = () => {
    setSelectedOptions([]);
    setFormValues(getInitialFormValues());
    setModalOpen(false);
  };

  const filteredData = search
    ? vendors.filter(
        (item) =>
          (item?.title?.toLowerCase()?.includes(search.toLowerCase()) ??
            false) ||
          (item?.category_name?.toLowerCase()?.includes(search.toLowerCase()) ??
            false) ||
          (item?.sub_category_name
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ??
            false),
      )
    : vendors;

  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      <SnackbarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />
      {/* Add Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderRadius: "20px",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{
            width: "30%",
            backgroundColor: "#FFF",
            borderRadius: 1,
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setModalOpen(true);
            setIsEditing(false);
          }}
          sx={{
            backgroundColor: "#28A745",
            "&:hover": { backgroundColor: "#218838" },
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Add Variant Properties
        </Button>
      </Box>

      {/* Vendor Table */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: "20px", p: 0, borderRadius: 2, boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>S.no</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Variant Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Sub-Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Properties</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData &&
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((vendor) => (
                  <TableRow key={vendor.variant_id}>
                    <TableCell>{vendor.variant_id}</TableCell>
                    <TableCell>{vendor.title}</TableCell>
                    <TableCell>{vendor.category_name}</TableCell>
                    <TableCell>{vendor.sub_category_name}</TableCell>
                    {/* <TableCell>{vendor.properties}</TableCell> */}
                    <TableCell>
                      {vendor.title === "Colors"
                        ? vendor.options.map((option) => (
                            <span
                              key={option.variant_option_id}
                              style={{
                                display: "inline-block",
                                width: "30px",
                                height: "30px",
                                backgroundColor: option.option_name,
                                margin: "5px",
                                borderRadius: "5px",
                              }}
                              title={option.option_name}
                            />
                          ))
                        : // For other titles, show the option names as text
                          vendor.options.length > 0
                          ? vendor.options.map((option, index) => (
                              <span key={option.variant_option_id}>
                                {option.option_name}
                                {index < vendor.options.length - 1 && ", "}
                              </span>
                            ))
                          : vendor.properties}
                    </TableCell>

                    {/* Action Column with 3 Dots Menu */}
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuClick(e, vendor)}>
                        <MoreVert />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) &&
                          selectedVendor?.variant_id === vendor.variant_id
                        }
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={handleEditVendor}>Edit</MenuItem>
                        <MenuItem
                          sx={{ display: "none" }}
                          // onClick={handleDelete}
                        >
                          Delete
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={vendors && vendors.length ? vendors.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Add/Edit Vendor Modal */}
      <Modal open={isModalOpen} onClose={() => handleModalClose()}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">
              {isEditing ? "Edit Variant" : "Add Variant Properties"}
            </Typography>
            <IconButton onClick={() => resetData()}>
              <Close />
            </IconButton>
          </Box> */}
          <Typography variant="h6">
            {isEditing ? "Edit Variant" : "Add Variant Properties"}
          </Typography>

          <Box>
            <Box sx={{ display: "flex", gap: 0, mt: 2 }}>
              {/* <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Variant Name</InputLabel>
        <Select
          native
          value={newVendor.variant_id || ""}
          error={!!variantNameError}
          onChange={(e) => setNewVendor({ ...newVendor, variant_id: e.target.value })}
        >
          <option value="" disabled>Select Variant</option>
          {vendorsData.map((variant) => (
            <option key={variant.variant_id} value={variant.variant_id}>
              {variant.title}
            </option>
          ))}
        </Select>
      </FormControl> */}

              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Variant Name</InputLabel>
                <Select
                  native
                  // value={

                  //   newVendor.variant_id ||
                  //   (selectedVendor && selectedVendor.variant_id) ||
                  //   ""
                  // }

                  value={formValues ? formValues.variant_id : ""}
                  error={!!variantNameError}
                  onChange={(e) =>
                    // setNewVendor({ ...newVendor, variant_id: e.target.value })
                    setFormValues({ ...formValues, variant_id: e.target.value })
                  }
                  label="Variant Name"
                  sx={{
                    // Adjust the padding to ensure the text doesn't overlap with the underline
                    "& .MuiSelect-select": {
                      paddingTop: "24px", // Add padding to push the text down
                      color: "red",
                    },
                    // Ensure the underline (border) is above the text
                    "& .MuiInput-underline:before": {
                      top: "10px", // Move the underline up
                    },
                  }}
                >
                  {/* <option value="" disabled>
      Select Variant
    </option> */}
                  <option value="" />
                  {vendors &&
                    vendors.map((variant) => (
                      <option
                        key={variant.variant_id}
                        value={variant.variant_id}
                      >
                        {variant.title}
                      </option>
                    ))}
                </Select>
              </FormControl>

              <IconButton
                color="primary"
                onClick={handleAddOptionClick}
                sx={{ mb: 2, mt: 1 }}
              >
                <AddIcon />
              </IconButton>
            </Box>

            <Box sx={{ mt: 2 }}>
              {/* {newVendor.selectedVariants.map((variantId) => {
          const variant = vendorsData.find(v => v.variant_id === variantId);
          return (
            <Box key={variantId} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <TextField
                value={variant?.title || ""}
                disabled
                sx={{ flexGrow: 1 }}
              />
              <IconButton
                color="secondary"
                onClick={() => handleRemoveVariant(variantId)}
              >
                <RemoveIcon />
              </IconButton>
            </Box>
          );
        })} */}

              <LoadingOverlay open={isLoadingProgress} />

              {showOptionInput && (
                <Box className="flex items-center gap-2 mb-4">
                  <Box sx={{ display: "flex", gap: 0 }}>
                    <TextField
                      size="small"
                      fullWidth
                      value={newOption}
                      onChange={(e) => setNewOption(e.target.value)}
                      helperText={
                        propertiesError && (
                          <Typography
                            sx={{
                              textAlign: "left",
                              // marginTop: 1,
                              color: "red",
                            }}
                          >
                            {propertiesError}
                          </Typography>
                        )
                      }
                      // onChange={
                      //   (e) => setNewVendor({ ...newVendor, properties: e.target.value })
                      // }
                      onKeyPress={handleKeyPress}
                      placeholder="Enter option"
                      autoFocus
                      className="bg-white"
                    />
                    <IconButton
                      onClick={handleOptionSubmit}
                      className="bg-green-50 hover:bg-green-100"
                      sx={{
                        bgcolor: "rgba(0, 128, 0, 0.1)",
                        "&:hover": {
                          bgcolor: "rgba(0, 128, 0, 0.2)",
                        },
                      }}
                    >
                      <Check className="text-green-600" color="green" />
                    </IconButton>
                  </Box>
                </Box>
              )}

              {/* {isEditing ? selectedOptions.map((option, index) => (
        <Chip
              key={index}
              label={option.option_name}
              onDelete={() => handleRemoveOption(option.option_name,option.variant_option_id)}
              deleteIcon={<CloseIcon className="h-4 w-4" />}
              className="bg-gray-100"
            />
          )) : selectedOptions.map((option, index) => (
            <Chip
                  key={index}
                  label={option}
                  onDelete={() => handleRemoveOption(option)}
                  deleteIcon={<CloseIcon className="h-4 w-4" />}
                  className="bg-gray-100"
                />
              ))}
           */}

              {/* {isEditing ? (
    selectedOptions.map((option, index) => (
        <Chip
            key={`${option.variant_option_id}-${index}`}
            label={option.option_name}
            onDelete={() => handleRemoveOption(option.option_name, option.variant_option_id)}
            deleteIcon={<CloseIcon className="h-4 w-4" />}
            className="bg-gray-100 m-1"
        />
    ))
) : (
    selectedOptions.map((option, index) => (
        <Chip
            key={`option-${index}`}
            label={option}
            onDelete={() => handleRemoveOption(option)}
            deleteIcon={<CloseIcon className="h-4 w-4" />}
            className="bg-gray-100 m-1"
        />
    ))
)} */}

              {isEditing
                ? Array.isArray(selectedOptions) &&
                  selectedOptions.map((option, index) => (
                    <Chip
                      key={`${option.variant_option_id}-${index}`}
                      label={option.option_name}
                      onDelete={() =>
                        handleRemoveOption(
                          option.option_name,
                          option.variant_option_id,
                        )
                      }
                      deleteIcon={<CloseIcon className="h-4 w-4" />}
                      className="bg-gray-100 m-1"
                    />
                  ))
                : Array.isArray(selectedOptions) &&
                  selectedOptions.map((option, index) => (
                    <Chip
                      key={`option-${index}`}
                      label={option}
                      onDelete={() => handleRemoveOption(option)}
                      deleteIcon={<CloseIcon className="h-4 w-4" />}
                      className="bg-gray-100 m-1"
                    />
                  ))}
            </Box>
          </Box>
          <TextField
            fullWidth
            label="Properties"
            variant="outlined"
            value={formValues.options}
            error={!!propertiesError}
            helperText={
              propertiesError && (
                <Typography sx={{ textAlign: "left", color: "red" }}>
                  {propertiesError}
                </Typography>
              )
            }
            onChange={(e) =>
              // setNewVendor({ ...newVendor, properties: e.target.value })
              setFormValues({ ...formValues, options: e.target.value })
            }
            sx={{ mb: 2, display: "none" }}
          />

          {isEditing ? (
            <FormControl fullWidth sx={{ mb: 5, mt: 2 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={formValues.status} // Default to 1 (Active)
                onChange={(e) => {
                  console.log("select", e.target.value);
                  // setNewVendor((prev) => ({ ...prev, status: e.target.value }));
                  setFormValues({ ...formValues, status: e.target.value });
                }}
                label="Status"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Deactive</MenuItem>
              </Select>
            </FormControl>
          ) : null}
          <Box sx={{ mb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleAddVendor}
              sx={{ mb: 1 }}
            >
              {isEditing ? "Update" : "Add Variant Properties"}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              // onClick={handleCloseModal}
              onClick={() => resetData()}
            >
              CLOSE
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
